import { PASSWORD, USERNAME } from "./consts";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useLoginMutation } from "@/services";
import { setCookie } from "@/lib/setCookie";
import { routes } from "@/routes/utils";
import { getRequiredFields, removeEmptyFields, roles } from "@/lib/utils";
import { setLoggedInUserData } from "@/redux/slices";
import { useDispatch } from "react-redux";
import { schema } from "./validations";
import { toast } from "@/components";

const useLogin = () => {
  const navigate = useNavigate();
  const [isPassword, setIsPassword] = useState<boolean>(true);
  const dispatch = useDispatch();

  const form = useForm<any>({
    defaultValues: {
      [USERNAME]: "",
      [PASSWORD]: "",
    },
    resolver: zodResolver(schema),
  });

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const { mutate: loginMutate, isPending: isLoginPending } = useLoginMutation({
    onError: (error?: any) => {
      toast({
        type: "error",
        message:
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong",
      });
      return error?.response?.data?.message;
    },
    onSuccess: (data) => {
      if (data?.data?.accessToken) {
        const user = { ...data.data?.user };
        if (user?.userType == roles.admin.value) {
          dispatch(setLoggedInUserData(user));
          setCookie("accessToken", data?.data?.accessToken);
          setCookie("refreshToken", data?.data?.refreshToken);
          navigate(`/${routes.admin}`);
        } else if (
          user?.roleProjectMap?.some((role: any) => role.roleCode == roles.pm.value)
        ) {
          ('redirect')
          dispatch(setLoggedInUserData(user));
          setCookie("accessToken", data?.data?.accessToken);
          setCookie("refreshToken", data?.data?.refreshToken);
          navigate(`/${routes.pm}`);
        } else {
          toast({
            type: "warn",
            message: "You don't have permission to access this portal",
          });
        }
      }
    },
  });

  const onSubmit = (data: any) => {
    const _data = removeEmptyFields(data);
    loginMutate({ data: _data });
  };

  const onEyeIconClick = () => {
    setIsPassword(!isPassword);
  };

  const Icon = isPassword ? Eye : EyeOff;

  const onForgotClick = () => {
    navigate(`/${routes.forgotPassword}`);
  };
  return {
    navigate,
    form,
    requiredFields,
    onSubmit,
    onEyeIconClick,
    isPassword,
    Icon,
    isLoginPending,
    onForgotClick,
  };
};

export default useLogin;
